import { ActionType, createAsyncAction } from 'typesafe-actions'
import { Failure, Request, Success } from './types'
import { ChatState } from '../../types'

export const fetchMoreChatsAction = createAsyncAction(
  '@chat/FETCH_MORE_CHATS_REQUEST',
  '@chat/FETCH_MORE_CHATS_SUCCESS',
  '@chat/FETCH_MORE_CHATS_FAILURE'
)<Request, Success, Failure>()

const request = (state: ChatState, action: ActionType<typeof fetchMoreChatsAction.request>): ChatState => {
  const [firstStatus] = action.payload.status
  switch (firstStatus) {
    case 'open':
      return {
        ...state,
        isLoadingFetchMoreChatsOpen: true
      }
    case 'in_progress':
      return {
        ...state,
        isLoadingFetchMoreChatsInProgress: true
      }
    default:
      return {
        ...state,
        isLoadingFetchMoreChatsFinished: true
      }
  }
}

const success = (state: ChatState, { payload }: ActionType<typeof fetchMoreChatsAction.success>): ChatState => {
  const [firstStatus] = payload.status
  switch (firstStatus) {
    case 'open':
      return {
        ...state,
        isLoadingFetchMoreChatsOpen: false,
        openChats: [...state.openChats, ...payload.chats]
      }
    case 'in_progress':
      return {
        ...state,
        isLoadingFetchMoreChatsInProgress: false,
        inProgressChats: [...state.inProgressChats, ...payload.chats]
      }
    default:
      return {
        ...state,
        isLoadingFetchMoreChatsFinished: false,
        finishedChats: [...state.finishedChats, ...payload.chats]
      }
  }
}

const failure = (state: ChatState, action: ActionType<typeof fetchMoreChatsAction.failure>): ChatState => {
  const [firstStatus] = action.payload.status
  switch (firstStatus) {
    case 'open':
      return {
        ...state,
        isLoadingFetchMoreChatsOpen: false,
        isErrorOnFetchMoreChatsOpen: true
      }
    case 'in_progress':
      return {
        ...state,
        isLoadingFetchMoreChatsInProgress: false,
        isErrorOnFetchMoreChatsInProgress: true
      }
    default:
      return {
        ...state,
        isLoadingFetchMoreChatsFinished: false,
        isErrorOnFetchMoreChatsFinished: true
      }
  }
}

export const fetchMoreChatsHandle = { asyncAction: fetchMoreChatsAction, request, success, failure }
